import { BaseReducerState} from '../../../services'
import { ActionTypes } from './actions'
import { SiteRecentBill, RecentBillsAPIResponse } from './types'

export type RecentBillsState = BaseReducerState & {
  data: [SiteRecentBill]
}

export const initialState: RecentBillsState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const recentBillsState = (
  state: RecentBillsState = initialState,
  action: { type: string; res: any }
): RecentBillsState => {
  switch (action.type) {
    case `${ActionTypes.GET_RECENT_BILLS_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_RECENT_BILLS_DATA}_SUCCESS`: {
      const { success, data, message } = <RecentBillsAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_RECENT_BILLS_DATA}_FAILURE`:
      const res = <RecentBillsAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_RECENT_BILLS_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
